// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"bd31a851","990":"795fc6e0"}[chunkId] + ".chunk.css";
};